<script lang="ts">
  import { onMount } from "svelte";
  import { ApiService } from "../../services/api.service";
	import BlueButton from "../BlueButton.svelte";

	import Checkbox from "../../atoms/forms/Checkbox.svelte";
	import FormWithLabel from "../../molecules/FormWithLabel.svelte";
	import SectionBoard from "../../molecules/SectionBoard.svelte";

	export let klass = ""

	let	loading = false
	let id = 0
	let text = ''

	const handleText = (event) => {
  	text = event.detail.value
	}

	const save = async () => {
		const client = ApiService.createClient()
		loading = true
		const { data } = await client.post('/mail/signature', {
			id,
			text
		})
		console.log(data)
		loading = false
	}

	onMount(async () => {
		const client = ApiService.createClient()
		const { data } = await client.get('/mail/signature')
		console.log(data)
		if (!data.mailSignature) {
			return
		}
		id = data.mailSignature.id
		text = data.mailSignature.text
	})
</script>

<SectionBoard klass={klass}>
	<h2 class="font-semibold">
		メール署名
	</h2>

	<div class="mt-6">
		<FormWithLabel
			label="署名"
			input={handleText}
			value={text}
			inputType="textarea"
		/>
	</div>

	<BlueButton rounded klass="mt-4" click={save} loading={loading}>
		更新する
	</BlueButton>
</SectionBoard>